export const BULK_ACTION_TYPE = [
  { key: 'order_cancel', value: 'order_cancel', label: 'Order Cancel' },
  {
    key: 'inventory_stock_add',
    value: 'inventory_stock_add',
    label: 'Inventory Stock Add',
  },
  {
    key: 'product_create',
    value: 'product_create',
    label: 'Product Create',
  },
  {
    key: 'shelf_create',
    value: 'shelf_create',
    label: 'Shelf Create',
  },
  {
    key: 'vendor_product_create',
    value: 'vendor_product_create',
    label: 'Vendor Product Create',
  },
  {
    key: 'po_line_create',
    value: 'po_line_create',
    label: 'PO Line Create',
  },
];

export const BULK_ACTION_SELECT = {
  field: 'type',
  options: [
    { key: '', label: 'Please Select Type...', value: '' },
    ...BULK_ACTION_TYPE,
  ],
};
